export default {
	how_it_works: 'Cómo éste funciona',
	become_a_tutor: 'Conviértete en tutor',
	// teachOnAirClass: 'Enseñar en AirClass',
  airClassBlog: 'AirClass Blog',
	our_tutors: 'Nuestros tutores',
	one_on_one: 'Airclass 1 a 1',
	happy_kids: 'Niños felices',
	home: 'Inicio',
	prices: 'Precios',
	partner: 'Socios con nosotros',
	more: 'Más',
	login: 'Iniciar sesión',
	logout: 'Cerrar sesión',
	app_download: 'Descargue la App',
	invite_gift: 'Regalo de recomendación',
	invite_friends: 'recomendar a mis amigos',
	setting: 'Perfil & Ajustes',
	faq: 'Preguntas Frecuentes',
	main_home: 'Página de inicio',
	// TODO: 待翻译文本
	courses: 'Clases',
	profileInfo: 'Información de perfil',
	transactionRecord: 'Registro de la transacción',
	remindContent: 'Tu próxima clase está programada para comenzar a {time}',
	check: 'Revisar',
	en: 'English',
	es: 'Español',
	tr: 'Türkçe',
	china: '中文',
	header_line: 'https://web-data.zmlearn.com/image/5sq19czEhkS3cb9ocNf7cz/img_inviteheadline%402x.png',
};
